import { Box, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { APP_COLORS } from "../../../../utils/constants";
import api from "../../../../api/axios";
import Notification from "./Notification";
import SubmitBtn from "./SubmitBtn";
import { inputs } from "./inputs";
import Modal from "./Modal";
import { isCompanyEmail } from "./isCompanyEmail";

const initialValues = Object.fromEntries(inputs.map(({ id }) => [id, ""]));

export default function Form() {
  const [values, setValues] = React.useState(initialValues);
  const [errors, setErrors] = React.useState([]);

  const [loading, setLoading] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);

  const [apiResponse, setApiResponse] = React.useState({
    status: "",
    msg: "",
    notify: false,
  });

  const onChange = (e) => {
    const { name, value } = e.target;

    setErrors(errors.filter((e) => e.field !== name));
    setValues({ ...values, [name]: value });
  };

  const onSubmit = async () => {
    const newErrors = [];

    inputs.forEach(({ id, label }) => {
      const value = values[id]?.trim();

      // Empty check
      if (!value) {
        newErrors.push({ field: id, message: `${label} is required` });
        return;
      }

      // Email validation
      if (id === "email") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          newErrors.push({ field: id, message: "Invalid email address" });
          return;
        }
        // if (!isCompanyEmail(value)) {
        //   newErrors.push({
        //     field: id,
        //     message: "Inserted email should be a Business email",
        //   });
        //   return;
        // }
      }

      // Phone validation (digits only, min length 8, max length 15 for example)
      if (id === "phone") {
        const phoneRegex = /^\+?[0-9]{8,15}$/;
        if (!phoneRegex.test(value)) {
          newErrors.push({ field: id, message: "Invalid phone number" });
          return;
        }
      }
    });

    setErrors(newErrors);

    ////////////// SEND API
    if (newErrors.length === 0) {
      try {
        setLoading(true);
        const res = await api.post("/contact", values);

        console.log("Success:", res.data);

        setOpenModal(true);
        setApiResponse({
          status: "success",
          notify: true,
          msg: "Your Message was sent Successfully.",
          user: res?.data?.user,
        });
        setValues(initialValues);
      } catch (err) {
        console.error("API Error:", err);

        setOpenModal(true);
        setApiResponse({
          status: "error",
          notify: true,
          msg: `Couldn't send your message,
          you can contact us directly via Email !`,
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Box>
      <Grid container>
        {inputs.map((input) => {
          const { id, label } = input;
          return (
            <Grid
              size={{ xs: 12, lg: id === "msg" ? 12 : 6 }}
              sx={{
                px: 2,
                py: 4,
              }}
              key={id}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "1.2rem",
                  opacity: 0.9,
                  fontWeight: 400,
                }}
              >
                {label.toUpperCase()}
                <span
                  style={{
                    color: errors.some((error) => error.field === id) && "red",
                  }}
                >
                  *
                </span>
              </Typography>
              <TextField
                name={id}
                value={values[id]}
                onChange={onChange}
                autoComplete="off"
                multiline={id === "msg"}
                maxRows={id === "msg" && 4}
                sx={{
                  "& input, textarea": {
                    color: APP_COLORS.BACKGROUND,
                    py: { xs: 1, lg: 2.1 },
                    fontSize: "1.1rem",
                    px: 2,
                  },

                  "& .MuiInput-underline:before": {
                    borderBottomColor: errors.some(
                      (error) => error.field === id
                    )
                      ? "red"
                      : APP_COLORS.BACKGROUND, // Default border color
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: APP_COLORS.BACKGROUND, // Hover border color
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: APP_COLORS.BACKGROUND, // Focused border color
                  },
                }}
                variant="standard"
                fullWidth
              />
              <Typography sx={{ color: "red", opacity: 0.6, pt: 0.5 }}>
                {errors.find((err) => err.field === id)?.message || ""}
              </Typography>
            </Grid>
          );
        })}
      </Grid>

      <Box sx={{ textAlign: "right", mr: 2 }}>
        <SubmitBtn onSubmit={onSubmit} loading={loading} />
      </Box>

      <Modal
        apiResponse={apiResponse}
        setApiResponse={setApiResponse}
        openModal={openModal}
        setOpenModal={setOpenModal}
        values={values}
      />

      {/* <Notification apiResponse={apiResponse} setApiResponse={setApiResponse} /> */}
    </Box>
  );
}
